<template>
  <div>
    <v-dialog
      v-model="isShow"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Aggiungi un documento</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            @submit.prevent="create"
          >
            <v-row class="ma-0">
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="form.title"
                  label="Titolo"
                  outlined
                  required
                  dense
                  :rules="[formRules.required]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="form.description"
                  label="Descrizione"
                  rows="3"
                  dense
                  outlined
                ></v-textarea>
              </v-col>
              <v-col
                v-if="!noPriority"
                cols="12"
              >
                <v-select
                  v-model="form.priority"
                  :items="priorityOpts"
                  value="standard"
                  label="Priorità"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                v-if="!noAction"
                cols="12"
              >
                <v-select
                  v-model="form.company_action_id"
                  :items="companySettingsFilteredList('document.action').map(act => ({ text: act.name, value: act.id }))"
                  value=""
                  label="Azione"
                  outlined
                  :rules="[formRules.required]"
                ></v-select>
              </v-col>
              <v-col
                v-if="!noStatus"
                cols="12"
              >
                <v-select
                  v-model="form.company_status_id"
                  :items="companySettingsFilteredList('document.status').map(sta => ({ text: sta.name, value: sta.id }))"
                  value="1"
                  label="Stato"
                  outlined
                  :rules="[formRules.required]"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn
                  class="ma-2"
                  :disabled="loading"
                  @click="closeModal"
                >
                  Chiudi
                </v-btn>
                <v-btn
                  :color="btnColor"
                  :dark="btnDark"
                  class="ma-2"
                  :loading="loading"
                  @click.prevent="create"
                >
                  Crea
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'DocumentCreate',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isPluginVersion: {
      type: Boolean,
      default: false,
    },
    noPriority: {
      type: Boolean,
      default: false,
    },
    noAction: {
      type: Boolean,
      default: false,
    },
    noStatus: {
      type: Boolean,
      default: false,
    },
    folderId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      initialForm: {},
      form: {},
      priorityOpts: [
        {
          text: 'Normale',
          value: 'standard',
        },
        {
          text: 'Bassa priorità',
          value: 'low',
        },
        {
          text: 'Urgente',
          value: 'high',
        },
      ],
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['formRules', 'companySettingsFilteredList', 'partnerSettings']),
    btnColor() {
      return this.partnerSettings?.colors?.btn ?? 'primary'
    },
    btnDark() {
      return this.partnerSettings?.colors?.btnDark ?? false
    },
  },
  watch: {
    folderId(val) {
      if (val) {
        this.form.folder_id = val
        this.initialForm.folder_id = val
      }
    },
  },
  mounted() {
    this.setInitialValuesFromSettings()
    this.setInitialValues()
    if (this.folderId) {
      this.form.folder_id = this.folderId
      this.initialForm.folder_id = this.folderId
    }
  },
  methods: {
    setInitialValuesFromSettings() {
      const settings = ['action', 'status']
      settings.forEach(setting => {
        // eslint-disable-next-line array-callback-return
        this.companySettingsFilteredList(`document.${setting}`).map(act => {
          if (act.is_default === 1) {
            const kset = `company_${setting}_id`
            this.initialForm[kset] = act.id
          }
        })
      })
    },
    setInitialValues() {
      this.form = {
        ...this.initialForm,
      }
    },
    async create() {
      if (this.$refs.form.validate()) {
        try {
          let resp = false
          this.loading = true
          if (this.isPluginVersion) {
            resp = await this.$api.createPluginDocProcedure(this.$route.params.id, this.form)
          } else {
            resp = await this.$api.createDocProcedure(this.$route.params.id, this.form)
          }

          this.isShow = false
          await this.$store.dispatch('set_alert', { msg: 'Documento creato con successo', type: 'success' })
          this.$emit('reload-data')
          await this.closeModal()
        } catch (e) {
          this.loading = false
          await this.$store.dispatch('set_alert', { msg: e.response.data.message, type: 'error' })
        }
      }
    },
    async closeModal() {
      await this.$refs.form.reset()
      await this.$emit('close')
      await this.setInitialValues()
      this.loading = false
    },
  },
}
</script>

<style scoped>

</style>
